<template>
  <base-widget style="height: 184px;">
    <div v-if="loading || user === null">
      <!-- skeletons for when state is loading -->
      <base-skeleton class="d-flex">
        <div class="col-2 justify-content-end">
          <div
            class="skeleton__circle"
          />
        </div>
        <div class="d-flex col-7 align-items-center justify-content-center">
          <div class="w-25">
            <div class="skeleton__item" />
            <div class="skeleton__item" />
          </div>
          <div class="ml-3 w-25">
            <div class="skeleton__item" />
            <div class="skeleton__item" />
          </div>
          <div class="ml-3 w-25">
            <div class="skeleton__item" />
            <div class="skeleton__item" />
          </div>
        </div>
        <div class="d-flex col-3">
          <div>
            <div class="d-flex align-items-center justify-content-center h-50">
              <div
                class="skeleton__item"
                style="width: 165px; height:43px"
              />
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <div
                class="skeleton__item"
                style="width: 165px; height:43px"
              />
            </div>
          </div>
        </div>
      </base-skeleton>
    </div>
    <div
      v-else
      class="row align-items-center d-flex"
    >
      <div class="col-2 justify-content-end" style="width: 100px; max-width: 130px; padding-left: 15px; padding-right: 0px;">
        <div class="d-flex">
          <avatar-editor
            v-if="showEditor"
            ref="editor"
            :initial-step="avatar ? 1 : 0"
            :pre-filled-image="avatar"
            :editor-title="avatar ? 'Edit Image':'Add Image'"
            @close-editor="onEditorClosed"
            @change-avatar="changeAvatar"
            @delete-avatar="deleteAvatar"
          />
          <base-avatar
            :size="104"
            :username="`${user.user.first_name} ${user.user.last_name}`"
            :img="avatar"
            :readonly="readonly"
            @click="loadImage"
          />
        </div>
        <!--<base-loading
          class="pt-1"
          :show="loading"
        />-->
      </div>
      <div class="col">
        <div class="d-flex">
          <div class="w-100">
            <base-hover v-slot="{isHover}">
              <div
                class="row editable-profile align-items-center m-0"
                :class="`${!readonly ? 'editable-profile--editable' : ''}`"
                @click="onStartEditing"
              >
                <div class="col-4">
                  <base-text
                    semi-bold
                    class="title-font"
                  >
                    <!--<div v-if="nameError">
                    <i class="error-message">Required</i>
                  </div>-->
                    <base-texteditable
                      v-if="editing"
                      placeholder="First name"
                      :value="first_name"
                      max-width="500px"
                      @input="first_name = $event"
                    />
                    <!--<div v-if="lastNameError">
                    <i class="error-message">Required</i>
                  </div>-->
                    <base-texteditable
                      v-if="editing"
                      placeholder="Last name"
                      :value="last_name"
                      max-width="500px"
                      @input="last_name = $event"
                    />
                    <span v-else>{{ first_name }} {{ last_name }}</span>
                  </base-text>
                  <base-text
                    light
                    class="pt-2"
                    style="color: #767676;font-size: 14px;"
                  >
                    <base-texteditable
                      v-if="editing"
                      placeholder="Based in"
                      :value="location"
                      max-width="500px"
                      @input="location = $event"
                    />
                    <span v-else>{{ location }}</span>
                  </base-text>
                </div>
                <div class="col-4">
                  <base-text
                    light
                    class="text-truncate"
                    size="m"
                  >
                    <!--<div>
                    <i v-if="editing && emailError" class="error-message">Required</i>
                  </div>-->
                    <base-texteditable
                      v-if="editing"
                      placeholder="Email"
                      :value="email"
                      max-width="180px"
                      custom-width="180px"
                      @input="email = $event"
                    />
                    <span v-else>{{ email }}</span>
                  </base-text>
                  <base-text
                    light
                    class="text-truncate pt-2"
                    size="m"
                  >
                    <base-texteditable
                      v-if="editing"
                      placeholder="Phone number"
                      :value="phone"
                      max-width="250px"
                      custom-width="250px"
                      @input="phone = $event"
                    />
                    <span v-else>{{ phone }}</span>
                  </base-text>
                </div>
                <div class="col-4">
                  <base-checkbox
                    v-model="iMessage"
                    block
                    black
                    label="iMessage"
                    :disabled="!editing"
                  />
                  <base-checkbox
                    v-model="whatsapp"
                    block
                    black
                    label="WhatsApp"
                    :disabled="!editing"
                  />
                </div>
                <div :class="`edit-pencil ${isHover && !editing && !readonly? 'show' : ''}`">
                  <base-icon icon="pencil" />
                </div>
              </div>
            </base-hover>
            <base-text
              v-if="editing"
              size="s"
              class="row d-flex justify-content-end w-100 float-right editbuttons"
            >
              <div
                class="p-3"
                @click="onCancel"
              >
                Cancel
              </div>
              <div class="button-save" @click="onSave">
                Save
              </div>
            </base-text>
          </div>
        </div>
      </div>
      <div class="col-2" style="padding-left: 0px; padding-right: 0px">
        <base-button
          class="profile-button"
          secondary
          block
          small
          @click="$router.push(`/admin/user/${user.pk}/manage-clients`)"
        >
          Manage Clients
        </base-button>

        <base-button
          class="profile-button mt-3"
          secondary
          block
          small
          @click="$emit('sign-in-as')"
        >
          Sign In As {{ user.user.first_name }}
        </base-button>
      </div>
    </div>
  </base-widget>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'AdminProfile',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
      email: '',
      phone: '',
      first_name: '',
      last_name: '',
      location: '',
      emailError: false,
      nameError: false,
      lastNameError: false,
      iMessage: false,
      whatsapp: false,
      temporaryAvatar: '', // Used when uploading a new avatar
      showEditor: false,
    };
  },
  computed: {
    avatar: {
      get() {
        return (this.temporaryAvatar) ? this.temporaryAvatar : this.user.profile_pic;
      },
      set(val) {
        this.temporaryAvatar = val;
      },
    },
  },
  watch: {
    user: {
      handler(newval) {
        if (newval !== null) this.setFields(newval);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onStartEditing() {
      if (this.readonly) return;
      this.editing = true;
    },
    loadImage() {
      this.showEditor = true;
      this.$nextTick().then(() => {
        this.$refs.editor.open();
      });
    },
    onEditorClosed() {
      this.showEditor = false;
    },
    changeAvatar({ file, image }) {
      this.$emit('change-avatar', file);
    },
    deleteAvatar() {
      this.user.profile_pic = null;
      this.avatar = null;
      this.$emit('delete-avatar');
    },
    onSave() {
      if (this.verifyData()) {
        return;
      }
      this.editing = false;
      this.$emit('edited', {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone,
        location: this.location,
        whatsapp: this.whatsapp,
        imessage: this.iMessage,
      });
      this.setFields(this.user); // When server responds, data will get updated
    },
    onCancel() {
      this.editing = false;
      this.setFields(this.user);
    },
    setFields(data) {
      EventBus.$emit('profileBreadcrumb', `${data.user.first_name} ${data.user.last_name}`);
      this.first_name = data.user.first_name;
      this.last_name = data.user.last_name;
      this.email = data.user.email;
      this.phone = data.phone_number ? data.phone_number : '';
      this.location = data.location ? data.location : '';
      this.iMessage = data.imessage;
      this.whatsapp = data.whatsapp;
      this.temporaryAvatar = data.profile_pic;
    },
    verifyData() {
      if (this.first_name === '') {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
      if (this.email === '') {
        this.emailError = true;
      } else {
        this.emailError = false;
      }
      if (this.last_name === '') {
        this.lastNameError = true;
      } else {
        this.lastNameError = false;
      }
      return (this.emailError || this.lastNameError || this.nameError);
    },
  },
};
</script>
<style lang="scss">
.confirm-stylist-name{
  font-family: $font-family-sans-serif-medium;
}
</style>
<style lang="scss" scoped>
::v-deep .card-body {
  padding: 35px 30px 30px 15px !important;
}
.editable-profile {
  height: 104px;
  padding: 0px;
  width: 100%;
  max-width: 1200px;
  padding: 1rem;
  transition: background-color .3s ease;

  &--editable:hover {
    background-color: #FAF9F7;
  }

  font-size: 13px;
}

.editbuttons {
  position: absolute;
  padding-right: 0.5rem;
  line-height: 0;
  padding-top: 0.4rem;

  &>div {
    cursor: pointer;
    transition: opacity .3s ease;

    &:hover {
      opacity: 0.6;
    }
  }
}

.edit-pencil {
  position: absolute;
  right: 30px;
  bottom: 4px;
  opacity: 0;
  transition: opacity .3s ease;

  &.show {
    opacity: 1;
  }
}

.profile-button {
  background: #FFFFFF !important;
  border: 1px solid #C6C6C6 !important;
  max-width: 140px;
  line-height: 100%;
  height: 36px;
  margin-left: auto;
  margin-right: auto;
}

.error-message {
  font-size: 12px;
  color: red;
}

.title-font {
  font-size: 16px;
}

::v-deep .skeleton__circle {
  height: 138px;
  width: 138px;
  border-radius:100px;
  max-width: 138px;
}
.button-save{
  color: #333333;
  padding: 15px 10px 15px 10px;
  border: 1px solid #C6C6C6;
  border-radius: 5px;
}
</style>
